<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedEngagementTypes"
      multi-select
      searchable
      :label="meta.filter.quickFilter ? '' : $t('Engagement type')"
      :list="engagementTypes"
      :placeholder="$t('All engagement types')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { EngagementType } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedEngagementTypes: ModelRef<string[]> = defineModel({
  default: () => [],
})

const engagementTypes = computed(() =>
  Object.values(EngagementType).map((type) => ({
    label: $t(
      Object.keys(EngagementType).find(
        (key) => EngagementType[key as keyof typeof EngagementType] === type,
      ) || type,
    ),
    value: type,
  })),
)
</script>
